import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

export const Footer = () => {
    return (
        <footer>
            <Container>
                <Row className='my-1'>
                    <Col xs="5" className='d-flex align-items-center'>

                    </Col>
                </Row>
            </Container>
        </footer>
    )
}
